import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @Input() isHandsetPortrait!: any;

  constructor(private router: Router,private storage: StorageService,) {}

  ngOnInit(): void {}

  goToSiteMap() {
    this.router.navigate(['/site-map']);
  }

  goToPage(pageName: string) {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';
    this.router.navigate([`info/${baniLanguageString}/${pageName}`]);
  }

  fetchLanguage(): string | null {
    return this.storage.get('language');
  }
}
